<template>
  <!-- Open button -->
  <v-list-item @click.stop="editSale">
    <v-icon class="secondary--text">mdi-pencil</v-icon>
    <v-list-item-title class="secondary--text">
      Editar venta
    </v-list-item-title>
  </v-list-item>
</template>

<script>
export default {
  name: "EditSaleMenuItem",
  props: {
    saleData: {
      type: Object
    }
  },
  data() {
    return {};
  },
  methods: {
    editSale() {
      this.$router.push({
        name: "edit-sale",
        params: { id: this.saleData._id }
      });
    }
  }
};
</script>
